package fr.frux.feature.premium

import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Instant

/** Date du jour au format `jj/mm/aaaa`, fuseau de l'appareil, sans table de noms de mois. */
internal fun formatPremiumDate(instant: Instant): String {
    val date = instant.toLocalDateTime(TimeZone.currentSystemDefault())
    val day = date.day.toString().padStart(2, '0')
    val month = date.monthNumber.toString().padStart(2, '0')
    return "$day/$month/${date.year}"
}
